var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 44,
    viewBox: "0 0 288 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 43C279.312 41.5357 256.253 19.7012 244.452 8.10989C239.849 3.58879 233.689 1 227.237 1H60.7631C54.3113 1 48.1507 3.58879 43.5478 8.10989C31.7469 19.7012 8.68768 41.5357 1 43H287Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287 43C279.312 41.5357 256.253 19.7012 244.452 8.10989C239.849 3.58879 233.689 1 227.237 1H60.7631C54.3113 1 48.1507 3.58879 43.5478 8.10989C31.7469 19.7012 8.68768 41.5357 1 43",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAnnouncement);
export default __webpack_public_path__ + "static/media/no-announcement.89992ad4af41169309876e839e4dafec.svg";
export { ForwardRef as ReactComponent };